import * as Yup from 'yup';
import { AppConfig } from '../../../shared/app-configs/app-config';
import { TCAppConfig } from '../../../shared/app-configs/tc-app-configs';
import apiService from '../../../shared/service/api-service';
import { ITransactionCertificateReqDto } from '../tc-models/tc-req-dto/transaction-certificate.req_dto';
import { BuyerSellerDetails } from '../tc-models/tc-req-dto/tc-buyer-seller-details.req_dto';
import { API_ROUTES } from '../../../shared/app-configs/sc-app-config';


export const buyerSellerDetailsService = {
  async saveBuyerSellerDetails(buyerSellerDetails: BuyerSellerDetails) {
    const response = await apiService.post<any, any>(`${AppConfig.BASE_URL}${TCAppConfig.BUYERS_SELLER_DETAILS}`, buyerSellerDetails)
    return response;
  },
  /**
 * Fetch Buyer and Seller Details by TC ID
 * @param tcId - The Transaction Certificate ID
 * @returns Promise resolving to the buyer and seller details
 */
  async getBuyerSellerDetails(tcId: number) {
    const response = await apiService.get<any>(
      `${AppConfig.BASE_URL}${TCAppConfig.GET_BUYERS_SELLER_DETAILS}`,
      { tcId } // Passing query parameters
    );
    return response;
  },
  async getTEDetails(queryParams: any) {

    const response = await apiService.get<any>(
      `${AppConfig.BASE_URL}${TCAppConfig.GET_TE_DETAILS}`,
      queryParams // Passing query parameters
    );
    return response;
  },

}
export const mlbuyerSellerDetailsService = {

  async getMLCODetails(queryParams: any) {

    const response = await apiService.get<any>(
      `${AppConfig.BASE_URL}${TCAppConfig.GET_ML_CO_DETAILS}`,
      queryParams // Passing query parameters
    );
    return response;
  },

  async getMLValidatedCODetails(queryParams: any) {
    const response = await apiService.get<any>(
      `${AppConfig.BASE_URL}${TCAppConfig.GET_ML_VALIDATED_CO_DETAILS}`,
      queryParams
    );
    return response;
  },

}
export const coNameDetailsService = {
  async getdtrackitCoNameDetails(queryParams: any) {

    const response = await apiService.get<any>(
      `${AppConfig.BASE_URL}${API_ROUTES.GET_CO_DTRACKIT_NAME}`,
      queryParams // Passing query parameters
    );
    return response;
  },
  async gethistoricCoNameDetails(queryParams: any) {

    const response = await apiService.get<any>(
      `${AppConfig.BASE_URL}${API_ROUTES.GET_CO_HISTORIC_NAME}`,
      queryParams // Passing query parameters
    );
    return response;
  },
}